<div class="help-page">
    <header class="help-header">
        <h4>{{ variables?.faqsAndDocs1 }}</h4>
        <p class="help-intro">{{ variables?.helpPageIntro }}</p>
        <p class="help-summary">{{ variables?.helpPageSummary }}</p>
    </header>

    <section class="help-quick-panel">
        <div class="help-quick-top">
            <h5>{{ variables?.helpQuickPanelTitle }}</h5>
            <input
                type="text"
                class="help-quick-search"
                [placeholder]="variables?.helpSearchPlaceholder || ''"
                [(ngModel)]="helpSearchTerm" />
        </div>

        <div class="help-role-filter" aria-label="Filtro de guía por rol">
            <button
                type="button"
                class="help-role-chip"
                *ngFor="let option of roleFilterOptions"
                [class.active]="selectedGuideRole === option.key"
                (click)="setGuideRole(option.key)">
                {{ option.label }}
            </button>
        </div>

        <p class="help-role-context">{{ roleContextMessage }}</p>

        <div class="help-quick-grid" *ngIf="filteredHelpUseCases.length > 0">
            <article class="help-quick-card" *ngFor="let item of filteredHelpUseCases">
                <span class="help-recommended-badge" *ngIf="isRecommendedForDetectedRole(item)">{{ variables?.helpRecommendedBadge }}</span>
                <h6>{{ item.title }}</h6>
                <p><strong>{{ variables?.helpCardWhatToDo }}</strong> {{ item.objective }}</p>
                <p><strong>{{ variables?.helpCardWhenToUse }}</strong> {{ item.whenToUse }}</p>
                <ol>
                    <li *ngFor="let step of item.steps">{{ step }}</li>
                </ol>
                <p class="help-quick-check"><strong>{{ variables?.helpCardValidate }}</strong> {{ item.validation }}</p>
                <p class="help-quick-error"><strong>{{ variables?.helpCardTypicalError }}</strong> {{ item.commonError }}</p>
                <button type="button" class="help-quick-link" (click)="setHelpSection(item.section)">
                    {{ variables?.helpCardOpenTopic }} {{ getSectionLabel(item.section) }}
                </button>
            </article>
        </div>

        <p class="help-no-results" *ngIf="filteredHelpUseCases.length === 0">{{ variables?.helpQuickNoResults }}</p>
    </section>

    <div class="help-layout">
        <aside class="help-sidebar">
            <div class="help-sidebar-header">{{ variables?.helpSidebarHeader }}</div>

            <nav class="help-submenu" aria-label="Submenú de secciones de ayuda">
                <button
                    type="button"
                    class="help-submenu-btn"
                    *ngFor="let section of filteredHelpSections"
                    [class.active]="activeHelpSection === section.key"
                    (click)="setHelpSection(section.key)">
                    {{ section.label }}
                </button>
            </nav>

            <button
                type="button"
                class="help-toggle-topics"
                *ngIf="!helpSearchTerm.trim() && hiddenTopicsCount > 0"
                (click)="toggleTopicsVisibility()">
                {{ showAllTopics ? variables?.helpShowLess : (variables?.helpShowMorePrefix + ' (' + hiddenTopicsCount + ')') }}
            </button>

            <p class="help-no-results" *ngIf="filteredHelpSections.length === 0">{{ variables?.helpNoSections }}</p>
        </aside>

        <main class="help-content">

    <section class="help-card">
        <h5 id="topic-01">{{ getTopicTitle('topic-01') }}</h5>
        <div [innerHTML]="getTopicBody('topic-01')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-02">{{ getTopicTitle('topic-02') }}</h5>
        <div [innerHTML]="getTopicBody('topic-02')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-03">{{ getTopicTitle('topic-03') }}</h5>
        <div [innerHTML]="getTopicBody('topic-03')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-04">{{ getTopicTitle('topic-04') }}</h5>
        <div [innerHTML]="getTopicBody('topic-04')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-05">{{ getTopicTitle('topic-05') }}</h5>
        <div [innerHTML]="getTopicBody('topic-05')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-06">{{ getTopicTitle('topic-06') }}</h5>
        <div [innerHTML]="getTopicBody('topic-06')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-07">{{ getTopicTitle('topic-07') }}</h5>
        <div [innerHTML]="getTopicBody('topic-07')"></div>
    </section>

    <section class="help-card help-card-highlight">
        <h5 id="topic-08">{{ getTopicTitle('topic-08') }}</h5>
        <div [innerHTML]="getTopicBody('topic-08')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-09">{{ getTopicTitle('topic-09') }}</h5>
        <div [innerHTML]="getTopicBody('topic-09')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-10">{{ getTopicTitle('topic-10') }}</h5>
        <div [innerHTML]="getTopicBody('topic-10')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-11">{{ getTopicTitle('topic-11') }}</h5>
        <div [innerHTML]="getTopicBody('topic-11')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-12">{{ getTopicTitle('topic-12') }}</h5>
        <div [innerHTML]="getTopicBody('topic-12')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-13">{{ getTopicTitle('topic-13') }}</h5>
        <div [innerHTML]="getTopicBody('topic-13')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-14">{{ getTopicTitle('topic-14') }}</h5>
        <div [innerHTML]="getTopicBody('topic-14')"></div>
    </section>

    <section class="help-card help-card-highlight">
        <h5 id="topic-15">{{ getTopicTitle('topic-15') }}</h5>
        <div [innerHTML]="getTopicBody('topic-15')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-16">{{ getTopicTitle('topic-16') }}</h5>
        <div [innerHTML]="getTopicBody('topic-16')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-17">{{ getTopicTitle('topic-17') }}</h5>
        <div [innerHTML]="getTopicBody('topic-17')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-18">{{ getTopicTitle('topic-18') }}</h5>
        <div [innerHTML]="getTopicBody('topic-18')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-19">{{ getTopicTitle('topic-19') }}</h5>
        <div [innerHTML]="getTopicBody('topic-19')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-20">{{ getTopicTitle('topic-20') }}</h5>
        <div [innerHTML]="getTopicBody('topic-20')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-21">{{ getTopicTitle('topic-21') }}</h5>
        <div [innerHTML]="getTopicBody('topic-21')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-22">{{ getTopicTitle('topic-22') }}</h5>
        <div [innerHTML]="getTopicBody('topic-22')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-23">{{ getTopicTitle('topic-23') }}</h5>
        <div [innerHTML]="getTopicBody('topic-23')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-24">{{ getTopicTitle('topic-24') }}</h5>
        <div [innerHTML]="getTopicBody('topic-24')"></div>
    </section>

    <section class="help-card">
        <h5 id="topic-25">{{ getTopicTitle('topic-25') }}</h5>
        <div [innerHTML]="getTopicBody('topic-25')"></div>
    </section>

        </main>
    </div>
</div>
